import React from 'react';

import { AppState } from 'types/appState';

export const AppStateContext = React.createContext<null | AppState>(null);
